export var MiscellaneousVendorsEnum;
(function (MiscellaneousVendorsEnum) {
    MiscellaneousVendorsEnum["APPLE"] = "Apple";
    MiscellaneousVendorsEnum["GOOGLE"] = "Google";
})(MiscellaneousVendorsEnum || (MiscellaneousVendorsEnum = {}));
//# sourceMappingURL=miscellaneous-vendors.enum.js.map